<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light" data-manual-filter body-class="px-3 px-md-4">
                <button type="button"
                    class="btn btn-outline-primary lg-filter-toggle w-100 d-flex justify-content-between align-items-center mb-2"
                    @click="toggleFilters">
                    <span class="d-flex align-items-center">
                        <b-icon icon="funnel" font-scale="1.1" class="mr-2"></b-icon>
                        <span>Filtros</span>
                    </span>
                    <b-icon :icon="filtersOpen ? 'chevron-up' : 'chevron-down'" font-scale="1.1"></b-icon>
                </button>

                <div class="lg-filter-container" v-show="filtersOpen">
                    <b-form-row class="mx-0" @keyup.enter="load">
                        <b-form-row class="mx-0" @keyup.enter="load">
                            <b-row class="mx-0">
                                <b-col lg="4" sm="12" class="text-left">
                                    <lg-finder-page-almoxarifado :departamento="form.departamento"
                                        id="finderAlmoxarifado" @onselect="handleSelectAlmoxarifado"
                                        v-model="form.almoxarifado" invalidFeedback="Informe um almoxarifado!"
                                        :prefix="'Itens Consumidos > '" />
                                </b-col>

                                <b-col lg="4" sm="6" class="">
                                    <lg-form-date invalidFeedback=" " description="" v-model="form.dataDe"
                                        label="Inicial:" />
                                </b-col>
                                <b-col lg="4" sm="6" style="margin-left:-20px">
                                    <lg-form-date invalidFeedback=" " description="" v-model="form.dataAte"
                                        label="Até:" />
                                </b-col>

                                <b-col lg="4" sm="12" class="text-left">
                                    <lg-finder-page-produto id="finderProdutoIC" @onselect="handleSelectProduto"
                                        v-model="form.produto" invalidFeedback="Produto deve ser informada!"
                                        description="" :title="'> Produto'" :prefix="'Itens Consumidos '" />
                                </b-col>

                                <b-col lg="4" sm="12" class="text-left">
                                    <lg-finder-page-unidade-administrativa id="finderUnidadeAdministrativa"
                                        @onselect="handleSelectUnidadeAdministrativa" v-model="form.departamento"
                                        invalidFeedback="Informe uma unidade administrativa!"
                                        :title="'Unidade Administrativa'" :prefix="'Itens Consumidos > '"
                                        :podeMudarDepartamento="temPrivilegioSelecionarUA() || temPrivilegioGerenciarAlmoxarifado()"
                                        :podeApagarDepartamento="false" />
                                </b-col>
                                <b-col lg="1" sm="12" class="text-left "></b-col>
                                <b-col lg="3" sm="4" class="d-flex justify-content-start align-items-center mt-2">
                                    <b-button id="apagarBtn" size="sm" pill style="height: 40px" @click="clearForm">
                                        <div class="btn-size-alinhamento">
                                            <b-icon icon="eraser" />
                                        </div>
                                        <b-tooltip title="Limpar" target="apagarBtn"></b-tooltip>
                                    </b-button>
                                </b-col>
                                <b-col lg="4" sm="12" class="text-left ">
                                    <lg-finder-page-subgrupo-produto :grupoProduto="grupoProduto" id="finderSubgrupo"
                                        @onSelect="handleSelectSubgrupo" v-model="form.subgrupo"
                                        invalidFeedback="Subgrupo deve ser informado!"
                                        :prefix="'Itens Consumidos > '" />
                                </b-col>

                                <b-col lg="4" sm="12" class="text-left ">
                                    <lg-finder-page-classe :apenasConsumo="true" id="finderClasse"
                                        @onselect="handleSelectClasse" v-model="form.classe"
                                        invalidFeedback="Informe uma Classe" :title="'Classe'"
                                        :prefix="'Itens Consumidos > '" />
                                </b-col>
                                <b-col lg="1" sm="12" class="text-left "></b-col>
                                <b-col lg="3" sm="4" class="d-flex justify-content-start align-items-center mt-2">

                                    <b-button class="mr-2 ml-2" style="height: 40px" size="sm" pill variant="primary"
                                        @click="load()" id="localizarItensConsumidos">
                                        <div class="btn-size-alinhamento">
                                            <b-icon icon="search" />
                                        </div>
                                        <b-tooltip title="Localizar" target="localizarItensConsumidos"></b-tooltip>
                                    </b-button>
                                </b-col>

                                <b-col lg="4" sm="8">
                                    <lg-form-input invalidFeedback="" description="" v-model="form.numero"
                                        label="Número:" />
                                </b-col>


                            </b-row>
                        </b-form-row>


                    </b-form-row>
                </div>

                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" show-empty>
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Carregando...</strong>
                        </div>
                    </template>
                </b-table>
                <div class="d-flex justify-content-end mt-2" v-if="temPrivilegioVisualizarSaldo()">
                    <span>{{
                        `Total de itens: ${this.quantidadeTotal != undefined ? this.quantidadeTotal : 0
                        }`
                    }}</span>
                </div>
                <div v-if="temPrivilegioVisualizarSaldo()" class="d-flex justify-content-end mt-2">
                    <span class="ml-3">
                        {{
                            `Valor Total dos itens: ${valorTotal != null
                                ? valorTotal.toLocaleString("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                })
                                : "R$0,00"
                            }`
                        }}
                    </span>
                </div>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"

import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import { FormResourceMixin } from "@/core/mixins/resource"
import LgFinderPageAlmoxarifado from "@/components/Finders/LgFinderPageAlmoxarifado.vue"
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"
import LgFinderPageProduto from "@/components/Finders/LgFinderPageProduto.vue"
import LgFinderPageSubgrupoProduto from "@/components/Finders/LgFinderPageSubgrupoProduto.vue"
import LgFinderPageClasse from "@/components/Finders/LgFinderPageClasse.vue"
import ItensConsumidosService from "@/core/api/ItensConsumidosService"
import PdfIcon from "@/core/assets/icons/pdf.png";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import DownloadArquivoService from "@/core/utils/DownloadArquivoUtil"

export default {
    components: {
        LgFormInput,
        LgFormDate,
        LgFinderPageProduto,
        LgFinderPageUnidadeAdministrativa,
        LgFinderPageAlmoxarifado,
        LgFinderPageSubgrupoProduto,
        LgFinderPageClasse,
    },
    mixins: [ListResourceMixin, FormResourceMixin],
    data() {
        return {
            pdf: PdfIcon,
            grupoProduto: { id: 4 },
            records: [],
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            valorTotal: 0,
            quantidadeTotal: 0,
            total: 0,
            totalPage: 0,
            page: 1,
            busy: false,
            filtersOpen: true,
            form: {
                departamento: {},
                almoxarifado: {},
                produto: {},
                subgrupo: {},
                classe: {},
                numero: "",
                dataDe: "",
                dataAte: "",
            },
        }
    },

    beforeMount() {
        const brand = JSON.parse(localStorage.getItem("context"))
        this.form.departamento = brand.departamento
        this.form.departamento.descricao = brand.departamento.nome

        this.$ItensConsumidosService = new ItensConsumidosService()
        this.$service = new ResourceService(`/api/tarefaspedido/findRetirada`)

        this.load()
    },

    watch: {
        page() {
            this.load()
        },
        form() {
            this.load()
        },
    },

    computed: {
        tableFields() {
            return [
                {
                    key: "pedidoId",
                    label: "Nº Pedido",
                    thStyle: "font-size: 12px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

                {
                    key: "dataAtual",
                    label: "Data",
                    thStyle: "font-size: 12px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    formatter: value =>
                        value ? new Date(value).toLocaleDateString("pt-BR") : "-",
                },

                {
                    key: "descricaoDepartamento",
                    label: "Unidade Administrativa",
                    thStyle: "font-size: 12px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

                {
                    key: "numeroProduto",
                    label: "Número Produto",
                    thStyle: "font-size: 12px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

                {
                    key: "descricaoResumida",
                    label: "Produto",
                    thStyle: "font-size: 12px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

                {
                    key: "qtdRetirada",
                    label: "Quantidade",
                    thStyle: "font-size: 12px; font-weight: 400; ",
                    tdStyle: "font-size: 13px; ",
                    thClass: "text-right",
                    tdClass: "text-right",
                    formatter: value => {
                        return value.toLocaleString("pt-BR", {
                            style: "decimal",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })
                    },
                },

                {
                    key: "somaQtdRetirada",
                    label: "Valor Total (R$)",
                    thStyle: "font-size: 12px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    thClass: "text-right",
                    tdClass: "text-right",
                    formatter: value => {
                        value != null
                            ? (value = value.toLocaleString("pt-BR", {
                                style: "decimal",
                                currency: "BRL",
                                minimumFractionDigits: 2,
                            }))
                            : (value = "R$0,00")
                        return value
                    },
                },
            ]
        },
    },

    methods: {
        toggleFilters() {
            this.filtersOpen = !this.filtersOpen
        },
        temPrivilegioGerenciarAlmoxarifado() {
            return verificaPrivilegio(PrivilegiosEnum.GERENCIAR_ALMOXARIFADO);

        },
        temPrivilegioVisualizarSaldo() {
            return verificaPrivilegio(PrivilegiosEnum.ITENS_CONSUMIDOS_VISUALIZAR_SALDO);

        },

        temPrivilegioSelecionarUA() {
            return verificaPrivilegio(PrivilegiosEnum.ITENS_CONSUMIDOS_SELECIONAR_OUTRA_UA);

        },






        async gerarPdfItensConsumidos() {


            var { data } = await new ResourceService(`/api/relatorio/gerar-relatorio-itens-consumidos`).get(`PDF/${this.form.departamento.id}`);
            DownloadArquivoService(data.pdf, data.nome);
        },
        async load() {
            let filtro = {}

            if (this.form.almoxarifado != undefined && this.form.almoxarifado.id) {
                filtro.almoxarifadoId = this.form.almoxarifado.id
            }
            if (
                this.form.numero != "" &&
                this.form.numero != undefined &&
                this.form.numero != null
            ) {
                filtro.numeroPedido = this.form.numero
            }
            if (this.form.produto != undefined && this.form.produto.id) {
                filtro.produtoId = this.form.produto.id
            }
            if (this.form.subgrupo != undefined && this.form.subgrupo.id) {
                filtro.subgrupoId = this.form.subgrupo.id
            }
            if (this.form.classe != undefined && this.form.classe.id) {
                filtro.classeId = this.form.classe.id
            }
            if (this.form.departamento != undefined && this.form.departamento.id) {
                filtro.departamentoId = this.form.departamento.id
            }

            if (this.form.dataDe != "" && this.form.dataDe != undefined) {
                filtro.dataDe = new Date(this.form.dataDe).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                });
            }

            if (this.form.dataAte != "" && this.form.dataAte != undefined) {
                filtro.dataAte = new Date(this.form.dataAte).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                });
            }

            if (this.form.dataDe && this.form.dataAte) {
                const ini = new Date(this.form.dataDe);
                const fim = new Date(this.form.dataAte);

                if (ini > fim) {
                    this.busy = false;
                    this.$notify({
                        type: "danger",
                        message: "Informe as datas corretamente.",
                    });
                    return;
                }
            }


            this.busy = true

            Promise.all([
                this.$ItensConsumidosService.getSomaValorTotalItensPedidosRetirada(
                    filtro
                ),
                this.$ItensConsumidosService.getSomaItensPedidosRetirada(filtro),
                this.$loadResource({
                    size: this.perPage,
                    page: this.page,
                    params: filtro,
                }),
            ]).then(response => {
                this.valorTotal = response[0].data
                this.quantidadeTotal = response[1].data
            })
        },

        async clearForm() {

            if (this.temPrivilegioGerenciarAlmoxarifado())
                this.form.departamento = {}
            this.form.almoxarifado = {}
            this.form.produto = {}
            this.form.subgrupo = {}
            this.form.classe = {}
            this.form.numero = ""
            this.form.dataDe = ""
            this.form.dataAte = ""

            this.load()
        },
        async geraPdf() { },
        handleSelectDepartamento(departamento) {
            this.form.departamento = departamento
            this.load()
        },

        handleSelectAlmoxarifado(almoxarifado) {
            this.form.almoxarifado = almoxarifado
            this.load()
        },

        handleSelectClasse(classe) {
            this.form.classe = classe
            this.load()
        },

        handleSelectUnidadeAdministrativa(departamento) {
            this.form.almoxarifado = {};
            this.form.departamento = departamento
            this.load()
        },

        handleSelectProduto(produto) {
            this.form.produto = produto
            this.load()
        },

        handleSelectSubgrupo(subgrupo) {
            this.form.subgrupo = subgrupo
            this.load()
        },
    },
}
</script>
